import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Message } from "element-ui";
import { getUserInfoDetailByYj } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew } from "@/mixins/index";
export default {
  mixins: [gmToolNew],
  data: function data() {
    return {
      dialogShow: false,
      paramsData: {
        server_day: "",
        role_id: "",
        server_id: "",
        game_id: '',
        env_id: '',
        page_size: 10,
        page: 1
      },
      tableData: [],
      total: 0,
      reqLoading: false
    };
  },
  created: function created() {},
  methods: {
    init: function init(data) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var server_day, role_id, server_id, game_id, env_id, server_channel, show_test;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                server_day = data.server_day, role_id = data.role_id, server_id = data.server_id, game_id = data.game_id, env_id = data.env_id, server_channel = data.server_channel, show_test = data.show_test;
                _this.paramsData = {
                  server_day: server_day,
                  role_id: role_id,
                  server_id: server_id,
                  game_id: game_id,
                  env_id: env_id,
                  server_channel: server_channel,
                  show_test: show_test
                };
                _this.paramsData.page_size = 10;
                _this.dialogShow = true;

                _this.getList(1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    resetForm: function resetForm(formName) {
      this.paramsData = {
        server_day: "",
        role_id: "",
        server_id: "",
        game_id: '',
        env_id: '',
        server_channel: '',
        show_test: '',
        page_size: 10,
        page: 1
      };
      this.$refs.ruleForm.clearValidate();
    },
    getList: function getList(e) {
      var _this2 = this;

      this.reqLoading = true;
      this.paramsData.page = e;
      getUserInfoDetailByYj(this.paramsData).then(function (res) {
        if (res.status == 200) {
          _this2.tableData = res.data.data;
          _this2.total = res.data.total;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    },
    dataFormSubmit: function dataFormSubmit(formName) {
      this.dialogShow = false;
    }
  }
};